/** @internal */
export const defaults = {
    chainId: 'aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906',
    rpc: 'https://eos.greymass.com',
    service: 'https://cb.anchor.link',
};
//# sourceMappingURL=link-options.js.map